import type { ChecklistItem } from '../types/schema'
import { getChecklistBlockState, type ChecklistBlockReason } from './checklistDependencyState'
import type { RepeatPagesInput } from '../services/repeat/types'

export type ChecklistBlockedTodoPolicy = {
  allowCompletion: boolean
  allowProof: boolean
  allowStatusChange: boolean
  allowComment: boolean
}

export type ChecklistBlockedTodoPolicySource = {
  checklistBlockedTodoPolicy?: Partial<ChecklistBlockedTodoPolicy> | null
  workspacePreferences?: {
    checklistBlockedTodoPolicy?: Partial<ChecklistBlockedTodoPolicy> | null
  } | null
}

export const DEFAULT_CHECKLIST_BLOCKED_TODO_POLICY: ChecklistBlockedTodoPolicy = {
  allowCompletion: false,
  allowProof: false,
  allowStatusChange: true,
  allowComment: true,
}

const DEPENDENCY_REASON_CODES = new Set<ChecklistBlockReason['code']>([
  'DEPENDENCY_INCOMPLETE',
  'DEPENDENCY_MISSING',
])

export function normalizeChecklistBlockedTodoPolicy(
  source?: ChecklistBlockedTodoPolicySource | null,
): ChecklistBlockedTodoPolicy {
  const direct = source?.checklistBlockedTodoPolicy
  const nested = source?.workspacePreferences?.checklistBlockedTodoPolicy
  const raw = direct ?? nested ?? null
  return {
    allowCompletion: raw?.allowCompletion ?? DEFAULT_CHECKLIST_BLOCKED_TODO_POLICY.allowCompletion,
    allowProof: raw?.allowProof ?? DEFAULT_CHECKLIST_BLOCKED_TODO_POLICY.allowProof,
    allowStatusChange: raw?.allowStatusChange ?? DEFAULT_CHECKLIST_BLOCKED_TODO_POLICY.allowStatusChange,
    allowComment: raw?.allowComment ?? DEFAULT_CHECKLIST_BLOCKED_TODO_POLICY.allowComment,
  }
}

export const getChecklistDependencyBlockState = (
  item: ChecklistItem,
  itemById: ReadonlyMap<string, ChecklistItem>,
  periodKey?: string,
  pages?: RepeatPagesInput,
  timeZone?: string,
) => {
  const reasons = getChecklistBlockState(item, itemById, periodKey, pages, timeZone).reasons
    .filter((reason) => DEPENDENCY_REASON_CODES.has(reason.code))
  return {
    isBlocked: reasons.length > 0,
    reasons,
    blockerCount: reasons.length,
  }
}
